import { jsx as c, jsxs as x, Fragment as Q } from "react/jsx-runtime";
import { useState as y, useRef as _, useEffect as b, useLayoutEffect as Y } from "react";
import { isEmpty as V } from "es-toolkit/compat";
import { noop as N } from "es-toolkit/function";
import C from "../../utils/classNames.js";
import { useDropDirection as Z } from "../../utils/useDropDirection.js";
import { DOWN as O, scrollItemIntoView as T, UP as g } from "../../utils/scrollItemIntoView.js";
import $ from "../../hooks/useEffectOnce.js";
import ee from "../../hooks/useKey.js";
import te from "./DropdownHeader.js";
import se from "./NoItemMessage.js";
import re from "../spinner/Spinner.js";
const B = "data-item-id", ne = 0, H = "focus", L = O, be = (h) => {
  const {
    isOpen: s = !1,
    isLoading: l = !1,
    updateDOMValues: u = N,
    onOpen: i = N,
    onSelect: p = N,
    onClose: E = N,
    options: o = [],
    autoDropDirection: j = !0,
    dropup: K = !1,
    pullRight: G = !1,
    useActiveClass: P = !1,
    focusedItemIndex: m,
    keyboardUsed: f,
    noItemMessage: W,
    dropdownClassName: X
  } = h, [n, k] = y(m || ne), [q, A] = y(f), w = _(L), r = _(null);
  b(() => {
    s && r.current && (r.current.scrollTop = 0);
  }, [s]), b(() => {
    typeof m == "number" && k(m), typeof f == "boolean" && A(f), s || (w.current = L);
  }, [m, f, s]), $(() => {
    const e = F();
    u(e);
  });
  const I = Z({ pullRight: G, dropup: K, autoDropDirection: j, dropdownMenuRef: r }, [s]);
  Y(() => {
    if (r.current) {
      const e = r.current.parentElement;
      I.dropup ? e?.classList.add("dropup") : e?.classList.remove("dropup");
    }
  }, [I, r]), b(() => {
    r.current && u(F());
  }, [r.current]), b(() => {
    s && T(
      w.current || L,
      r.current,
      D()
    );
  }, [n, s]);
  const [v, U] = y(s);
  s && !v ? (i(I.dropup), U(s)) : !s && v && (E(), U(s)), ee((e) => {
    if (s)
      switch (e.key) {
        case "Escape": {
          E();
          break;
        }
        case "Tab": {
          E();
          break;
        }
        case "Enter": {
          z(e);
          break;
        }
        case "ArrowUp": {
          e.preventDefault(), M(g), T(g, r.current, D());
          break;
        }
        case "ArrowDown": {
          e.preventDefault(), M(O), T(O, r.current, D());
          break;
        }
      }
  });
  const M = (e) => {
    let t = 0;
    switch (e) {
      case g: {
        t = n <= 0 ? n : n - 1;
        break;
      }
      case O: {
        t = n === o.length - 1 ? n : n + 1;
        break;
      }
    }
    w.current = e;
    const a = e === g ? o.length - 1 : 0;
    k(t < 0 ? a : t), A(!0);
  }, S = () => r.current?.getElementsByTagName("a") || [], F = () => {
    if (r.current)
      return [...S()].map(
        (t) => ({
          id: t.getAttribute(B),
          text: t.textContent
        })
      );
  }, D = () => [...S()].find((t) => t.className.includes(H)), z = (e) => {
    if (e.preventDefault(), V(o))
      return;
    const t = D();
    if (t) {
      const a = o.find((d) => d.id === t.getAttribute(B));
      p(a);
    }
  }, J = (e) => {
    e.preventDefault();
    const t = e.currentTarget.getElementsByTagName("input")[0].value, a = o.find((d) => d.id === t);
    p(a);
  }, R = C("dropdown-menu", I.pullRight && "pull-right", X);
  return V(o) ? /* @__PURE__ */ c(se, { noItemMessage: W, className: R }) : /* @__PURE__ */ x("ul", { className: R, ref: r, role: "menu", children: [
    l && /* @__PURE__ */ c("div", { className: "display-flex justify-content-center padding-10", children: /* @__PURE__ */ c(re, {}) }),
    !l && o.map((e, t) => {
      if (e.header)
        return /* @__PURE__ */ c(te, { icon: e.icon, label: e.label }, e.id);
      const a = C(
        q && n === t ? H : "",
        e.disabled && "pointer-events-none",
        "display-flex align-items-center gap-3"
      ), d = C(
        e.disabled && "disabled",
        P && e.selected && "active"
      );
      return /* @__PURE__ */ c("li", { className: d, role: "listitem", children: /* @__PURE__ */ x(
        "a",
        {
          role: "menuitem",
          className: a,
          "data-item-id": e.id,
          "data-item-index": t,
          onClick: e.disabled ? void 0 : J,
          children: [
            /* @__PURE__ */ x("span", { className: "selected-option-dropdown-item", children: [
              e.icon && /* @__PURE__ */ c(Q, { children: e.icon }),
              e.label
            ] }),
            /* @__PURE__ */ c("input", { type: "hidden", value: e.id })
          ]
        }
      ) }, e.id);
    })
  ] });
}, Ne = (h, s, l) => {
  const u = h.filter((i) => i.text.toLowerCase().includes(s.toLowerCase()));
  return l.filter((i) => u.find((p) => p.id === i.id));
};
export {
  be as default,
  Ne as filterOptions
};
//# sourceMappingURL=BaseSelectDropdown.js.map
